import Phaser from 'phaser';
import { GAME_CONFIG, FACTIONS, EPOCHS } from '../data/GameConstants';

export default class TitleScene extends Phaser.Scene {
  constructor() {
    super({ key: 'TitleScene' });
  }

  create() {
    const { width, height } = this.cameras.main;

    // Background
    this.cameras.main.setBackgroundColor('#0A0505');

    // Create starfield background
    this.createStarfield();

    // Title
    const title1 = this.add.text(width / 2, height * 0.2, 'ANUNNAKI', {
      font: 'bold 72px Playfair Display',
      fill: '#FFD700',
      stroke: '#5D1916',
      strokeThickness: 4
    }).setOrigin(0.5);

    const title2 = this.add.text(width / 2, height * 0.3, 'VS HUMANS', {
      font: 'bold 48px Playfair Display',
      fill: '#22D3EE',
      stroke: '#0A0505',
      strokeThickness: 3
    }).setOrigin(0.5);

    const subtitle = this.add.text(width / 2, height * 0.38, 'The Ten Parts of Truth', {
      font: 'italic 24px Playfair Display',
      fill: '#D4AF37'
    }).setOrigin(0.5);

    // Pulsing animation for title
    this.tweens.add({
      targets: [title1],
      alpha: { from: 1, to: 0.7 },
      duration: 2000,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1
    });

    // Menu options
    const menuItems = [
      { text: 'NEW GAME', scene: 'FactionSelectScene' },
      { text: 'CONTINUE', scene: 'LoadGameScene', disabled: true },
      { text: 'OPTIONS', scene: 'OptionsScene', disabled: true },
      { text: 'LORE', scene: 'LoreScene' }
    ];

    const menuY = height * 0.55;
    const menuSpacing = 50;

    menuItems.forEach((item, index) => {
      const button = this.add.text(width / 2, menuY + index * menuSpacing, item.text, {
        font: '28px Manrope',
        fill: item.disabled ? '#666666' : '#FFFFFF'
      }).setOrigin(0.5);

      if (!item.disabled) {
        button.setInteractive({ useHandCursor: true });

        button.on('pointerover', () => {
          button.setStyle({ fill: '#FFD700' });
          button.setScale(1.1);
        });

        button.on('pointerout', () => {
          button.setStyle({ fill: '#FFFFFF' });
          button.setScale(1);
        });

        button.on('pointerdown', () => {
          this.cameras.main.fadeOut(500, 0, 0, 0);
          this.time.delayedCall(500, () => {
            this.scene.start(item.scene);
          });
        });
      }
    });

    // Version info
    this.add.text(10, height - 30, `v${GAME_CONFIG.version} - Development Build`, {
      font: '14px Manrope',
      fill: '#666666'
    });

    // Story teaser
    const storyBox = this.add.rectangle(width / 2, height * 0.88, width * 0.8, 80, 0x1A1A1A, 0.8);
    storyBox.setStrokeStyle(1, 0xFFD700);

    this.add.text(width / 2, height * 0.88, 
      '"The ancient gods didn\'t kill a father god. They killed the Truth.\nThey scattered the ten parts across the Earth. Only one remnant survives."', {
      font: 'italic 16px Manrope',
      fill: '#AAAAAA',
      align: 'center'
    }).setOrigin(0.5);

    // Fade in
    this.cameras.main.fadeIn(1000, 0, 0, 0);
  }

  createStarfield() {
    const { width, height } = this.cameras.main;
    const graphics = this.add.graphics();

    // Create random stars
    for (let i = 0; i < 200; i++) {
      const x = Phaser.Math.Between(0, width);
      const y = Phaser.Math.Between(0, height);
      const size = Phaser.Math.FloatBetween(0.5, 2);
      const alpha = Phaser.Math.FloatBetween(0.3, 1);

      graphics.fillStyle(0xFFFFFF, alpha);
      graphics.fillCircle(x, y, size);
    }

    // Add some golden stars (representing truth fragments)
    for (let i = 0; i < 10; i++) {
      const x = Phaser.Math.Between(0, width);
      const y = Phaser.Math.Between(0, height);
      
      graphics.fillStyle(0xFFD700, 0.8);
      graphics.fillCircle(x, y, 2);
    }
  }
}
